@if (fixedValue !== null) {
  {{ fixedValue }}
  <span class="source-pieces__fixed">{{ 'TRANS__IMPORT__GROUP_CARD__FIXED_VALUE' | translate }}</span>
} @else {
  <span class="source-pieces__arrow">←</span>
  <span class="source-pieces__pieces">
    @for (piece of pieces; track $index) {
      @switch (piece.kind) {
        @case ('column') {
          <span class="source-pieces__column">{{ piece.value }}</span>
        }
        @case ('lookup') {
          <span class="source-pieces__lookup">{{ piece.value || ('TRANS__IMPORT__LOOKUP_TAG' | translate) }}</span>
        }
        @case ('lookupValue') {
          <span class="source-pieces__lookup-value">
            <span class="source-pieces__lookup-value-arrow">→</span>
            <span class="source-pieces__lookup source-pieces__lookup--value">{{ piece.value }}</span>
          </span>
        }
        @case ('compose') {
          <span class="source-pieces__compose">
            {{ 'TRANS__IMPORT__VALUE_SOURCE__COMPOSE_SUMMARY' | translate: {count: piece.count} }}
          </span>
        }
        @case ('label') {
          <span class="source-pieces__label">«<span class="source-pieces__label-text">{{ piece.value }}</span>»</span>
        }
        @default {
          <span class="source-pieces__text">{{ piece.value }}</span>
        }
      }
    }
  </span>
}
